import React from "react";
import Icon from "@ant-design/icons";
import AutoDriveChangesSvg from "./AutoDriveChangesSvg";

const AutoDriveChangesIcon = (props) => (
  <Icon component={() => <AutoDriveChangesSvg {...props} />} {...props} />
);

export default AutoDriveChangesIcon;
